import {AnyAction} from 'redux';

const CONFIRM_EXIT_POPUPUP_VAL = 'CONFIRM_EXIT_POPUPUP_VAL'
const initialState ={
  confirmexitpopupval: ""
};

export async function setConfirmExitPopupVal(dispatch:any, confirmexitpopupval:any) {
  dispatch({
    type: CONFIRM_EXIT_POPUPUP_VAL,
    data: confirmexitpopupval
  });
}

const confirmExitPopupValReducer = (state = initialState, action:AnyAction) => {
switch (action.type) {
  case CONFIRM_EXIT_POPUPUP_VAL: {
      return {
        ...state,
        confirmexitpopupval: action.data
      };
    }

    default:
      return state;
  }
};

export default confirmExitPopupValReducer;